import { Fragment, useEffect, useState, useCallback, useRef } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import ErrorMessage from "../../errors/ErrorMessage";
import shortid from 'shortid'

export default function InputSelectSearch(props) {

    const options = [
        { id: 1, name: "AL" }, { id: 2, name: "AK" }, { id: 3, name: "AZ" }, { id: 4, name: "AR" }, { id: 5, name: "AS" },
        { id: 6, name: "CA" }, { id: 7, name: "CO" }, { id: 8, name: "CT" }, { id: 9, name: "DE" }, { id: 10, name: "DC" },
        { id: 11, name: "FL" }, { id: 12, name: "GA" }, { id: 13, name: "GU" }, { id: 14, name: "HI" }, { id: 15, name: "ID" },
        { id: 16, name: "IL" }, { id: 17, name: "IN" }, { id: 18, name: "IA" }, { id: 19, name: "KS" }, { id: 20, name: "KY" },
        { id: 21, name: "LA" }, { id: 22, name: "ME" }, { id: 23, name: "MD" }, { id: 24, name: "MA" }, { id: 25, name: "MI" },
        { id: 26, name: "MN" }, { id: 27, name: "MS" }, { id: 28, name: "MO" }, { id: 29, name: "MT" }, { id: 30, name: "NE" },
        { id: 31, name: "NV" }, { id: 32, name: "NH" }, { id: 33, name: "NJ" }, { id: 34, name: "NM" }, { id: 35, name: "NY" },
        { id: 36, name: "NC" }, { id: 37, name: "ND" }, { id: 38, name: "MP" }, { id: 39, name: "OH" }, { id: 40, name: "OK" },
        { id: 41, name: "OR" }, { id: 42, name: "PA" }, { id: 43, name: "PR" }, { id: 44, name: "RI" }, { id: 45, name: "SC" },
        { id: 46, name: "SD" }, { id: 47, name: "TN" }, { id: 48, name: "TX" }, { id: 49, name: "TT" }, { id: 50, name: "UT" },
        { id: 51, name: "VT" }, { id: 52, name: "VA" }, { id: 53, name: "VI" }, { id: 54, name: "WA" }, { id: 55, name: "WV" },
        { id: 56, name: "WI" }, { id: 57, name: "WY" }
    ]

    const [selected, setSelected] = useState("")
    const [query, setQuery] = useState("");

    const filteredOptions =
        query === ""
            ? options
            : options.filter((option) =>
                option.name
                    .toLowerCase()
                    .replace(/\s+/g, "")
                    .includes(query.toLowerCase().replace(/\s+/g, ""))
            );

    return (
        <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-1/2 px-3 md:mb-0 mb-4">
                {props.color ? (
                    <input className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg 
                    block w-full p-2.5`}
                        id={props.id1} value={props.value1} onChange={props.handleInputChange1(props.name1)} type={props.type1} placeholder={props.placeholder1}>
                    </input>
                ) : (
                    <input className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg 
                    focus:ring-primary-200 focus:border-primary-200 block w-full p-2.5`}
                        id={props.id1} value={props.value1} onChange={props.handleInputChange1(props.name1)} type={props.type1} placeholder={props.placeholder1}>
                    </input>
                )}

                {props.error1 ? (
                    <div className="mt-2">
                        <ErrorMessage message={props.message1}></ErrorMessage>
                    </div>
                ) : (
                    ""
                )}
            </div>
            <div className="w-full md:w-1/2 px-3">
                <div className="flex justify-center items-center">
                    <div className="w-full">
                        <Combobox className="z-100" value={selected} onSelect={props.handleInputChange2(props.name2)} onChange={setSelected}>
                            <div className="relative">
                                <div className="relative w-full cursor-default overflow-hidden rounded-lg border-none bg-gray-50 text-left sm:text-sm">

                                    <Combobox.Button className="flex w-full items-center">
                                        {props.color ? (
                                            <Combobox.Input
                                                placeholder={props.value2}
                                                className={`w-full bg-gray-50 border-2 border-gray-200 rounded-lg py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:border-2`}
                                                displayValue={(option) => option.name}
                                                onChange={(event) => setQuery(event.target.value)}
                                            />
                                        ) : (
                                            <Combobox.Input
                                                placeholder={props.value2}
                                                className={`w-full bg-gray-50 border-2 border-gray-200 rounded-lg py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-primary-200 focus:border-primary-200 focus:border-2`}
                                                displayValue={(option) => option.name}
                                                onChange={(event) => setQuery(event.target.value)}
                                            />
                                        )}

                                    </Combobox.Button>
                                </div>
                                <Transition
                                    as={Fragment}
                                    //   enter="transition ease-in duration-100"
                                    //   enterFrom="opacity-0"
                                    //   enterTo="opacity-100"
                                    leave="transition ease-in duration-100"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                    afterLeave={() => setQuery("")}
                                >
                                    <Combobox.Options className="absolute mt-1 max-h-40 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                        {filteredOptions.length === 0 && query !== "" ? (
                                            <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                                                Nothing found.
                                            </div>
                                        ) : (
                                            filteredOptions.map((option) => (
                                                <div key={shortid.generate()}>
                                                    {props.color ? (
                                                        <Combobox.Option
                                                            key={shortid.generate()}
                                                            className={({ active }) =>
                                                                `relative cursor-pointer select-none py-2 pl-10 pr-4 ${active ? `bg-[#334155] text-white` : "text-gray-900"
                                                                }`
                                                            }
                                                            value={option}
                                                        >
                                                            {({ selected, active }) => (
                                                                <>
                                                                    <span
                                                                        className={`block truncate ${selected ? "font-medium" : "font-normal"
                                                                            }`}
                                                                    >
                                                                        {option.name}
                                                                    </span>
                                                                    {(selected) ? (
                                                                        <span
                                                                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : `text-gray-900`
                                                                                }`}
                                                                        >
                                                                            <CheckIcon
                                                                                className="h-5 w-5"
                                                                                aria-hidden="true"
                                                                            />
                                                                        </span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </Combobox.Option>
                                                    ) : (
                                                        <Combobox.Option
                                                            key={shortid.generate()}
                                                            className={({ active }) =>
                                                                `relative cursor-pointer select-none py-2 pl-10 pr-4 ${active ? `bg-primary-200 text-white` : "text-gray-900"
                                                                }`
                                                            }
                                                            value={option}
                                                        >
                                                            {({ selected, active }) => (
                                                                <>
                                                                    <span
                                                                        className={`block truncate ${selected ? "font-medium" : "font-normal"
                                                                            }`}
                                                                    >
                                                                        {option.name}
                                                                    </span>
                                                                    {(selected) ? (
                                                                        <span
                                                                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : `text-gray-900`
                                                                                }`}
                                                                        >
                                                                            <CheckIcon
                                                                                className="h-5 w-5"
                                                                                aria-hidden="true"
                                                                            />
                                                                        </span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </Combobox.Option>
                                                    )}
                                                </div>
                                            ))
                                        )}
                                    </Combobox.Options>
                                </Transition>
                            </div>
                        </Combobox>
                    </div>
                </div>
                {props.error2 ? (
                    <div className="mt-2">
                        <ErrorMessage message={props.message2}></ErrorMessage>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    )
}